import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import wasteWater from "./wasteWater";
import videoItem from '@/views/dashboard/com/video';
import siteFiles from '@/views/dashboard/com/siteFiles.vue';
import { queryBigDataById, queryUrlBySiteId } from '@/api/api';
import Vue from 'vue';
import { ACCESS_TOKEN } from "@/store/mutation-types";
import noneImg from '@/assets/others/index/none2.png';
export default {
  data: function data() {
    return {
      widthChange: true,
      noneImg: noneImg,
      frameUrl: '',
      currentItem: '实时数据',
      navList: ['实时数据', '视频监控', '站点档案', '三维工况'],
      navList1: ['实时数据', '视频监控', '站点档案', '三维工况'],
      navList2: ['监测数据', '视频监控', '站点档案', '三维工况'],
      // navList: ['实时数据',  '视频监控'],
      // navList: ['实时数据', '超标分析', '预警分析', '视频监控'],
      selectId: '0',
      siteDetail: {},
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      },
      selectType: '0',
      siteId: '',
      timer: null
    };
  },
  watch: {
    selectType: function selectType(value) {
      if (value == '21') {
        this.navList = this.navList2;
        if (this.currentItem == '实时数据') this.currentItem = '监测数据';
      } else {
        this.navList = this.navList1;
        if (this.currentItem == '监测数据') this.currentItem = '实时数据';
      }
    }
  },
  components: {
    siteFiles: siteFiles,
    videoItem: videoItem,
    wasteWater: wasteWater
  },
  created: function created() {
    var _this = this;

    window.addEventListener('resize', function () {
      _this.widthChange = false;
      _this.timer = setTimeout(function () {
        _this.widthChange = true;
      }, 100);
    }, false);
  },
  destroyed: function destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    onTabChange: function onTabChange(item) {
      var _this2 = this;

      this.currentItem = item;

      if (item == '实时数据' || item == '监测数据' || item == '站点档案') {
        var data1 = JSON.parse(JSON.stringify(this.selectId));
        this.selectId = '0';
        this.$nextTick(function () {
          _this2.selectId = data1;
        });
      }

      if (item == '视频监控') {
        this.$nextTick(function () {
          _this2.$refs.video.getVideoList(_this2.siteId);
        });
      }
    },
    getType: function getType(data) {
      var _this3 = this;

      this.selectType = data.siteType;
      this.siteId = data.siteId;
      queryUrlBySiteId(data.siteId).then(function (res) {
        if (res.result) {
          _this3.frameUrl = res.result;
        } else {
          _this3.frameUrl = 'https://www.skyray-water.com:4001/view/yesep_env/3?site_id=' + data.siteId + '&isCron=1&token=' + Vue.ls.get(ACCESS_TOKEN);
        }
      }).catch(function () {
        _this3.frameUrl = 'https://www.skyray-water.com:4001/view/yesep_env/3?site_id=' + data.siteId + '&isCron=1&token=' + Vue.ls.get(ACCESS_TOKEN);
      });
      this.$nextTick(function () {
        _this3.getsiteDetail(data.siteId);

        if (_this3.currentItem == '视频监控') {
          _this3.$refs.video.getVideoList(data.siteId);
        }

        _this3.selectId = data.siteId.toString();
      });
    },
    getsiteDetail: function getsiteDetail(id) {
      var _this4 = this;

      queryBigDataById({
        id: id
      }).then(function (res) {
        if (res.success) {
          res.result.photo = res.result.photo != null ? _this4.getImageView(res.result.photo) : '';
          _this4.siteDetail = res.result;
        }
      });
    },
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    }
  }
};